<div class="container mt-5">
    @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
        {{apiError}}
    </div>
    }

    <div class="nav"><a href="javascript:void(0)" (click)="toggleCreateForm()" placement="start"
            ngbTooltip="Create a new project">+</a></div>

    @if (showCreateForm) {
    <div class="create-form card card-body mb-3">
        <mat-form-field>
            <mat-label>Project name</mat-label>
            <input matInput [(ngModel)]="newProjectName" placeholder="Ex. Brake controller FMEDA">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Custom id (optional)</mat-label>
            <input matInput [(ngModel)]="newProjectId" placeholder="Auto-generated if blank">
        </mat-form-field>
        <div class="create-actions">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="!newProjectName.trim()"
                (click)="createProject()">Create</button>
            <button type="button" class="btn btn-secondary btn-sm" (click)="toggleCreateForm()">Cancel</button>
        </div>
    </div>
    }

    <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. brake" #input>
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell *matCellDef="let element"> {{element.role}} </td>
        </ng-container>

        <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Owner </th>
            <td mat-cell *matCellDef="let element"> {{ownerLabel(element)}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element">
                <a href="javascript:void(0)" (click)="openProject(element)">Open&nbsp;</a>
                <a [hidden]="element.role !== 'OWNER'" href="javascript:void(0)"
                    (click)="deleteProject(element.id)">Delete</a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of projects">
    </mat-paginator>
</div>